/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CourtResponse,
  CreateCourtRequest,
  ProblemDetails,
  UpdateCourtRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CourtResponseFromJSON,
    CourtResponseToJSON,
    CreateCourtRequestFromJSON,
    CreateCourtRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateCourtRequestFromJSON,
    UpdateCourtRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateCourtOperationRequest {
    createCourtRequest: CreateCourtRequest;
}

export interface DeleteCourtRequest {
    id: string;
}

export interface GetAvailableCourtDistrictsRequest {
    excludeCourtId?: string;
}

export interface GetCourtByIdRequest {
    id: string;
}

export interface UpdateCourtOperationRequest {
    id: string;
    updateCourtRequest: UpdateCourtRequest;
}

/**
 * CourtsApi - interface
 * 
 * @export
 * @interface CourtsApiInterface
 */
export interface CourtsApiInterface {
    /**
     * 
     * @param {CreateCourtRequest} createCourtRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    createCourtRaw(requestParameters: CreateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>>;

    /**
     */
    createCourt(requestParameters: CreateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    deleteCourtRaw(requestParameters: DeleteCourtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteCourt(requestParameters: DeleteCourtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    getAllCourtsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourtResponse>>>;

    /**
     */
    getAllCourts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourtResponse>>;

    /**
     * 
     * @param {string} [excludeCourtId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    getAvailableCourtDistrictsRaw(requestParameters: GetAvailableCourtDistrictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>>;

    /**
     */
    getAvailableCourtDistricts(requestParameters: GetAvailableCourtDistrictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    getCourtByIdRaw(requestParameters: GetCourtByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>>;

    /**
     */
    getCourtById(requestParameters: GetCourtByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateCourtRequest} updateCourtRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtsApiInterface
     */
    updateCourtRaw(requestParameters: UpdateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>>;

    /**
     */
    updateCourt(requestParameters: UpdateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse>;

}

/**
 * 
 */
export class CourtsApi extends runtime.BaseAPI implements CourtsApiInterface {

    /**
     */
    async createCourtRaw(requestParameters: CreateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>> {
        if (requestParameters['createCourtRequest'] == null) {
            throw new runtime.RequiredError(
                'createCourtRequest',
                'Required parameter "createCourtRequest" was null or undefined when calling createCourt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/courts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCourtRequestToJSON(requestParameters['createCourtRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourtResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCourt(requestParameters: CreateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse> {
        const response = await this.createCourtRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteCourtRaw(requestParameters: DeleteCourtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCourt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/courts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCourt(requestParameters: DeleteCourtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCourtRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllCourtsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourtResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/courts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourtResponseFromJSON));
    }

    /**
     */
    async getAllCourts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourtResponse>> {
        const response = await this.getAllCourtsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAvailableCourtDistrictsRaw(requestParameters: GetAvailableCourtDistrictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['excludeCourtId'] != null) {
            queryParameters['excludeCourtId'] = requestParameters['excludeCourtId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/courts/districts/available`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getAvailableCourtDistricts(requestParameters: GetAvailableCourtDistrictsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getAvailableCourtDistrictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCourtByIdRaw(requestParameters: GetCourtByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCourtById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/courts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourtResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCourtById(requestParameters: GetCourtByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse> {
        const response = await this.getCourtByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCourtRaw(requestParameters: UpdateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourtResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCourt().'
            );
        }

        if (requestParameters['updateCourtRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCourtRequest',
                'Required parameter "updateCourtRequest" was null or undefined when calling updateCourt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/courts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCourtRequestToJSON(requestParameters['updateCourtRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourtResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCourt(requestParameters: UpdateCourtOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourtResponse> {
        const response = await this.updateCourtRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
